import { render, staticRenderFns } from "./loadOtherAdd.vue?vue&type=template&id=4511a2f6&"
import script from "./loadOtherAdd.vue?vue&type=script&lang=js&"
export * from "./loadOtherAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports